import React, { useState } from "react";

import { useIsMobile } from "src/shared/utilities/customHooks";

import VoucherModal from "../VoucherModal/VoucherModal";
import * as S from "./styled";

const DesktopVoucherBadge = () => {
  const isMobile = useIsMobile();
  const [modalOpen, setModalOpen] = useState(false);
  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  if (isMobile) {
    return null;
  }

  return (
    <S.VoucherBadgeContainer>
      <S.VoucherBadgeText>
        Searching with a housing voucher, like Section 8?
      </S.VoucherBadgeText>
      <S.VoucherButton
        aria-label="Open for more details"
        onClick={handleModalOpen}
      >
        See Tips
      </S.VoucherButton>
      <VoucherModal isOpen={modalOpen} onRequestClose={handleModalClose} />
    </S.VoucherBadgeContainer>
  );
};

export default DesktopVoucherBadge;
